<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-code-pen`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M44.995 32.812L45 15.707a1 1 0 00-.5-.866L24.498 3.289a1 1 0 00-1.002.001L3.5 14.873a1 1 0 00-.499.865V32.31a1 1 0 00.501.866l19.995 11.535a1 1 0 001.001 0L44.99 32.84a.013.013 0 00.005-.006.012.012 0 000-.007v-.016zM26 18.836V9l14 8.082L31.481 22 26 18.836zM22 9L8 17.11 16.44 22 22 18.78V9zm-5.492 18L22 30.213V39L9 31.393 16.508 27zM39 31.412L31.443 27 26 30.177V39l13-7.588zM41 22v6l-5-3 5-3zm-29 3l-5-3v6l5-3zm12 2l-4-2 4-2 4 2-4 2z"/></svg>
</template>
<script>

export default {
  name: 'IconCodePen',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
